import {Component, effect, inject, input, Signal, signal} from '@angular/core';
import {Layout, Perspective} from '@selpia/shared/models';
import {DataBatchFacade} from '@selpia/data-batch/data-access';
import {AppConfigFacade} from '@selpia/app-config/data-access';
import {OptionsFacade} from '@selpia/options/data-access';
import {FeatureKpiListComponent} from '@selpia/data-batch/feature-kpi-list';
import {FeatureKpiGridComponent} from '@selpia/feature-kpi-grid';

@Component({
  selector: 'lib-feature-kpi',
  imports: [FeatureKpiListComponent, FeatureKpiGridComponent],
  templateUrl: './feature-kpi.component.html',
  styleUrl: './feature-kpi.component.css',
})
export class FeatureKpiComponent {
  readonly #dataBatchFacade = inject(DataBatchFacade);
  readonly #appConfigFacade = inject(AppConfigFacade);
  readonly #optionsFacade = inject(OptionsFacade);

  readonly tileViewPage = input.required<string>();
  readonly reportPath = input<string>();

  constructor() {
    this.#loadData();
  }

  topPerspective = signal<Perspective | undefined>(undefined);
  protected readonly layout: Signal<Layout> = this.#optionsFacade.layout;

  #loadData() {
    const e1 = effect(() => {
      const totalLevel = this.#appConfigFacade.dimensions()
        ?.at(0)
        ?.levels
        .find(level => level.levelNumber === 0);

      if (totalLevel) {
        const KpiPerspective: Perspective = {
          date: undefined,
          filterDimensions: [],
          focusDimensionLevel: totalLevel,
          includeTotal: true,
        };

        this.topPerspective.set(KpiPerspective);

        this.#dataBatchFacade.loadDataBatch(KpiPerspective);
        e1.destroy();
      }
    }, {manualCleanup: true});
  }

  protected readonly Layout = Layout;
}
